/* Keep DOM order, keyboard order and the visible grid in agreement at both sizes. */
(() => {
  const mobile = window.matchMedia('(max-width: 760px)');

  function initialize(root) {
    const grid = root.querySelector('.jjt-plp__grid');
    const library = root.querySelector('[data-jjt-feature-library]');
    if (!grid || !library || root.dataset.jjtFeaturesReady) return;
    root.dataset.jjtFeaturesReady = 'true';
    const features = Array.from(library.querySelectorAll('template')).slice(0, 5)
      .map(template => template.content.firstElementChild.cloneNode(true));

    function arrange() {
      const products = Array.from(grid.children).filter(card => card.matches('.jjt-card'));
      features.forEach(feature => feature.remove());
      // Desktop: rows 2/right, 4/left, 6/right, 8/left, 10/right.
      // Mobile: a full-width square feature after every four product cards.
      const intervals = mobile.matches ? [4, 8, 12, 16, 20]
        : products.length < 6 ? [3] : [5, 8, 15, 18, 25];
      intervals.forEach((after, index) => {
        if (!features[index] || products.length <= after) return;
        products[after - 1].after(features[index]);
      });
    }

    arrange();
    mobile.addEventListener('change', arrange);
    root.addEventListener('jjt:products-added', arrange);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) mobile.removeEventListener('change', arrange);
    });
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-jjt-plp]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
